/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Button from "react-bootstrap/Button";
import MasterList from "../../../common/MasterList";
import { useTranslation } from "react-i18next";

const ConfirmReworkJobCard = (props) => {
  const { t } = useTranslation();

  const handleClick = (e, row) => {
    e.preventDefault();
    props.handleConfirm(row);
  };

  const columnsData = [
    {
      name: t("msg_reports.msg_jobstatus_report.actions"),
      cell: (row) => (
        <>
          {row.jobstatus === "REWORK-COMPLETE" ? (
            <Button
              className="btn btn-success"
              onClick={(e) => handleClick(e, row)}
            >
              {t("msg_common.confirm")}
            </Button>
          ) : (
            <Button className="btn btn-primary" disabled={true}>
              {t("msg_common.confirm")}
            </Button>
          )}
        </>
      ),
      center: true,
      width: "120px",
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcard}
          </span>
        </>
      ),
    },
    {
      name: t("msg_trasaction.rework_jobcard.rework_reason"),
      selector: (row) => row.reasonCode,
      sortable: true,
      width: "220px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.reasonCode + " : " + row.reasonName}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.rework_fromdept"),
      selector: (row) => row.reworkDeptCode,
      sortable: true,
      width: "220px",
      cell: (row) => (
        <>
          {row.reworkDeptCode ? (
            <span className="bg-table-status bg-table-first-status">
              {row.reworkDeptCode} - {row.reworkDeptName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.rework_count"),
      selector: (row) => row.count,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.count} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.rework_OKCount"),
      selector: (row) => row.reworkOKQuanity,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {row.reworkOKQuanity}{" "}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.rework_RejectCount"),
      selector: (row) => row.reworkRejectQuantity,
      sortable: true,
      width: "130px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {row.reworkRejectQuantity}{" "}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_common.status"),
      selector: (row) => row.jobstatus,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          {row.jobstatus === "REWORK-CONFIRMED" ? (
            <span className="bg-table-status bg-table-success-status">
              {row.jobstatus}
            </span>
          ) : (
            <span className="bg-table-status bg-table-new-status">
              {row.jobstatus}
            </span>
          )}
        </>
      ),
    },
    {
      name: t("msg_trasaction.rework_jobcard.rework_assigned_to"),
      selector: (row) => row.assignedUserId,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row.assignedFirstName}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.rework_jobcard.reworked_operator"),
      selector: (row) => row.createdUserName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.createdUserName}
          </span>
        </>
      ),
    },
  ];

  return (
    <>
      <h5 className="machineStatusTitle">
        {t("msg_trasaction.rework_jobcard.rework_confirm_header")}
      </h5>
      <MasterList
        columnsData={columnsData}
        rowsData={props.rowsData}
        handleClose
        cardHeader={false}
      />
    </>
  );
};

export default ConfirmReworkJobCard;
